import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse, PageQuery } from '../types/api.types';
import { VehicleOwner } from '../types/owner.types';

@Injectable({ providedIn: 'root' })
export class OwnersService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/rental/api/vehicle-owners`;

  /** List vehicle owners (admin, paginated). `page` is 1-indexed. */
  list(query: PageQuery = {}): Observable<ApiPageResponse<VehicleOwner>> {
    let params = new HttpParams()
      .set('pageable', 'true')
      .set('page', String(query.page ?? 1))
      .set('size', String(query.size ?? 10))
      .set('isDeleted', String(query.isDeleted ?? false));
    if (query.search?.trim()) {
      params = params.set('search', query.search.trim());
    }
    return this.http.get<ApiPageResponse<VehicleOwner>>(this.base, { params });
  }

  /** Get a single owner by id (admin). */
  get(id: number): Observable<VehicleOwner> {
    return this.http.get<VehicleOwner>(`${this.base}/${id}`);
  }

  /** Get the owner profile for a given user id (admin or self). */
  getByUserId(userId: number): Observable<VehicleOwner> {
    return this.http.get<VehicleOwner>(`${this.base}/user/${userId}`);
  }
}
